import { render, staticRenderFns } from "./KBKLimitsList.view.vue?vue&type=template&id=ccffc4d6&"
import script from "./KBKLimitsList.view.vue?vue&type=script&lang=js&"
export * from "./KBKLimitsList.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccffc4d6')) {
      api.createRecord('ccffc4d6', component.options)
    } else {
      api.reload('ccffc4d6', component.options)
    }
    module.hot.accept("./KBKLimitsList.view.vue?vue&type=template&id=ccffc4d6&", function () {
      api.rerender('ccffc4d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/common/partials/kbk-limits/view/KBKLimitsList.view.vue"
export default component.exports